export const pageSourceToAnalytics = {
  'property_page': 'property_page',
  'manage_bulletins': 'manage_bulletins_page',
  'manage_bulletins_page': 'manage_bulletins_page',
};
